import { useMediaQuery } from '@mui/material'
import { Navigate } from 'react-router'

import Projects from '../projects'

function ProjectIndex() {
  const mobile = useMediaQuery('(max-width:600px)')

  return <>{mobile ? <Navigate to="/redirect-to-app" /> : <Projects />}</>
}

export default ProjectIndex
